import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import MainApp from './pages/MainApp';
import AuthCallback from './pages/AuthCallback';
import AdminDashboard from './pages/AdminDashboard';
import BookingPage from './pages/BookingPage';
import TaxonomyExplorerPage from './pages/TaxonomyExplorerPage';
import CallRoom from './pages/CallRoom';
import PublicProfilePage from './pages/PublicProfilePage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/explore" element={<TaxonomyExplorerPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/app/*" element={<MainApp />} />
        <Route path="/call/:bookingId" element={<CallRoom />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/book/:userId" element={<BookingPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/u/:username" element={<PublicProfilePage />} />
        <Route path="/u/@:username" element={<PublicProfilePage />} />
        {/* Redirect any old routes */}
        <Route path="/dashboard" element={<Navigate to="/app" replace />} />
        <Route path="/leaderboard" element={<Navigate to="/app" replace />} />
        <Route path="/influencer/*" element={<Navigate to="/app" replace />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
